import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const API_URL = 'https://admin.shendudata.com:8085/api';

const api_headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { ...api_headers, X_KEY: localStorage.getItem('key') },
});

const axiosCSVInstance = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'text/csv',
    'Content-Type': 'application/json',
    X_KEY: localStorage.getItem('key'),
  },
});

axios.interceptors.request.use(
  (config) => {
    config.headers['X_KEY'] = localStorage.getItem('key');
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 403) {
      localStorage.clear();
    }

    return Promise.reject(error);
  },
);

const getEndpoint = (endpoint, configId) => {
  const isObject = typeof configId === 'object';
  const id = configId && !isObject ? `${configId}` : '';
  const selectEndpoint = `${endpoint}${id}`;

  return selectEndpoint;
};

const get_thunk = (prefix, endpoint) => {
  return createAsyncThunk(prefix, async (config, thunkAPI) => {
    try {
      const query = typeof config === 'object' ? config : {};
      // axiosInstance.headers.X_KEY = localStorage.getItem('x-key');
      const response = await axiosInstance.get(
        getEndpoint(endpoint, config),
        query,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  });
};

const get_csv_thunk = (prefix, endpoint) => {
  return createAsyncThunk(prefix, async (config, thunkAPI) => {
    try {
      const query = typeof config === 'object' ? config : {};
      // axiosInstance.headers.X_KEY = localStorage.getItem('x-key');
      const response = await axiosCSVInstance.get(
        getEndpoint(endpoint, config),
        query,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  });
};

const post_thunk = (prefix, endpoint) => {
  return createAsyncThunk(prefix, async (payload, thunkAPI) => {
    try {
      const data = payload.data ? payload.data : payload;

      const response = await axiosInstance.post(
        getEndpoint(endpoint, payload),
        data,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  });
};

export { get_thunk, post_thunk, get_csv_thunk };
export default axiosInstance;
